import axios from "axios";
import { getUrlApi } from "../utils/util";

class AccountService {
    async getBalance() {
        var url = `${await getUrlApi()}/account`;
        return axios.get(`${url}/balance`, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }
}

export default new AccountService();
